import { Injectable } from '@angular/core';
import { HttpConfigService } from '../http.config/http.config.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
export class JobLocation {
  id: number;
  parent: number;
  name: string;
  toString(): string {
    return this.name;
  }
}
@Injectable({
  providedIn: 'root'
})
export class LocationsService {
  private loadingLocations: Observable<JobLocation[]>;
  private LOCATIONS: JobLocation[];
  get locations(): JobLocation[] {
    if ((this.LOCATIONS === undefined || this.LOCATIONS === null) &&
      (this.loadingLocations === undefined || this.loadingLocations == null)) {
      this.loadingLocations = this.getLocations();
    }
    return this.LOCATIONS;
  }
  constructor(private httpConfig: HttpConfigService, private http: HttpClient) {
  }

  getLocations() {
    const request = this.http.post<JobLocation[]>(`${this.httpConfig.apiPath}/locations/get.php`, {});
    request.subscribe((data: JobLocation[]) => {
      this.LOCATIONS = data;
      console.log(this.LOCATIONS);
    }, error => {
      console.log(error);
    }, () => { });
    return request;
  }

 
}
